module.exports = __webpack_public_path__ + "static/media/bg_human.19e3399c.gif";